import React from 'react'
import { Row, Col, Image } from "antd";
import { RightArrowIcon } from 'svgIcon';
import MonogramIcon from "assets/images/mongram.jpg";
import { baseImageURL } from 'utils/env';
import { useGlobalMerchant } from 'utils/helper';

const ECEProductComponent = ({ filterProductList, handleCartAction, addedToCart }: any) => {
  const { globalMerchantCurrency } = useGlobalMerchant();
  return (
    <Row gutter={{ xs: 20, sm: 20, md: 20, lg: 20 }} >
      {filterProductList &&
        filterProductList.map((product: any) => (
          <Col key={product.product_id} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 8 }}>
            <div className="pCard">
              <div className="pCardHeader">
                <Image
                  src={product.img !== null ? `${baseImageURL}${product.img}` : MonogramIcon}
                  alt="product image"
                />
              </div>
              <div className="pCardBody">
                <h2 className="pCardTitle textCenter">{product.product_name}</h2>
                <p className="pCardAmount textCenter">{product.price} {globalMerchantCurrency}</p>
                <span className="pCardContent">{product.description}</span>
              </div>
              <div className="pCardFooter dFlex alignCenter justifyBetween">
                <div
                  className={product.qty <= 0 ? "disable left" : "left"}
                  onClick={() => product.qty > 0 && handleCartAction(product.product_id, product)}>
                  <p className={product.qty <= 0 ? "disable dFlex gap10 alignCenter" : "dFlex gap10 alignCenter"}>
                    {addedToCart[product.product_id] ? "Remove From Cart" : "Add To Cart"}
                    <RightArrowIcon />
                  </p>
                </div>
                <div className={product.qty <= 0 ? "disable right" : "right"}>
                  {product.qty <= 0 ? <p className='disable'>Out Of Stock</p> : <p>in stock</p>}
                </div>
              </div>
            </div>
          </Col>
        ))}
    </Row>
  )
}

export default ECEProductComponent